import { Component, Input, HostBinding } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'action-panel',
  templateUrl: 'action-panel.component.html',
  styleUrls: ['action-panel.component.scss'],
})
export class ActionPanelComponent {
  @Input() showActionPanel: boolean = true;

  @HostBinding('class.action-panel') isActionPanel = true;
  @HostBinding('class.action-panel-fixed') isActionPanelFixed = true;
  @HostBinding('class.bgcolor-white') bgColorWhite = true;
  @HostBinding('attr.data-ghost') ghostAttr = 'action-panel';

  @HostBinding('class.action-panel-hidden') get isHidden() {
    return !this.showActionPanel;
  }

  @HostBinding('class.action-panel-small')
  @Input() isSmall: boolean = false;

  @HostBinding('class.vesion2')
  @Input() version2: boolean = false;
}
